import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-408f4274"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Withdrawal" }
const _hoisted_2 = { class: "Withdrawal-title" }
const _hoisted_3 = { class: "Withdrawal-form-hint" }
const _hoisted_4 = { class: "Withdrawal-form-email" }
const _hoisted_5 = { class: "Withdrawal-form-email-text" }
const _hoisted_6 = { class: "Withdrawal-form-email-btn" }
const _hoisted_7 = { class: "Withdrawal-form-btn" }

import { reactive, computed, onMounted, watch, ref, toRaw } from 'vue'
import axios from 'axios'
import { t } from '@/plugins/i18n'
import { Withdrawal as createRules } from '@/views/signup/components/rules'
import { useGetCode } from '@/views/signup/components/utils'
import { sendEmailGetCode as sendEmailGetCodeRes, getWithdrawalMsg, getCalculateAmount as getCalculateAmountRes, applyWithdrawal } from '@/apis/fund'
import { useStore } from 'vuex'
import { useRequest } from '@/util/useLoading'
import { ElMessage as message } from 'element-plus'
import { useRtfix } from '@/store'
import { useRouter } from 'vue-router'
import uploadApplication from './uploadApplication.vue'
import { getTotherToken } from '@/apis/user'


export default /*#__PURE__*/_defineComponent({
  props: ['platType', 'shopInfo'],
  emits: ['close'],
  setup(__props, { emit: emits }) {

const props = __props
const store = useStore()
const userData = computed(() => store.getters.user)
const router = useRouter()



// 提现渠道选择列表
const withdrawChannelTypeList = [
  {
    label: t('银行卡'),
    value: '1'
  }
]

// 口座类别选择列表
const kzTypeList = [
  {
    label: t('普通'),
    value: '1'
  },
  {
    label: t('综合'),
    value: '2'
  }
]

onMounted(() => {
  getToken()
  // getMsg()
})

const data = reactive({
  show: true,
  // 可用金额
  availableAmount: 0,
  // 上传请求书组件状态
  upload: false,
  token: ''
})

// 表单数据
const form: any = reactive({
  // 提现渠道
  withdrawChannelType: '',
  // 银行名称
  bankName: '',
  // 支店名
  bankAddress: '',
  // 口座类别
  kzType: '',
  // 银行账号
  bankNo: '',
  // 收款人名称
  beneficiaryName: '',
  // 提现金额（rmb）
  withdrawAmountRmb: undefined,
  // 提现手续费
  withdrawFee: '',
  // 汇率
  exchangeRate: 0,
  // 费率
  feeRate: 0,
  // 提现金额（jpy）
  withdrawAmountJp: '',
  // 提现原因
  withdrawReason: '',
  // 电子邮件地址
  email: userData.value.customerEmail,
  // 邮箱验证码
  emailCode: '',
  // 系统来源
  systemSource: props.platType === 'd2c' ? '1' : '2',
  // 请求书
  requestBookUrl: '',
  // 用户id 取店铺下customerId
  customerId: props.shopInfo.customerId
})

watch(() => form.bankNo, val => {
  form.bankNo = val.replace(/[^\d]/g, '')
})

// 发送验证码
const sendEmailGetCode = () => {
  const formData = {
    bankNo: form.bankNo,
    email: userData.value.customerEmail
  }
  return sendEmailGetCodeRes(formData)
}

const { count, tip, disabled, getCode } = useGetCode(
  'withdrawalEmailCode',
  sendEmailGetCode
)

disabled.value = false
const rules = createRules(form, disabled)

const formRef = ref()

// 获取提现信息
const getMsg = () => {
  // const token = 'eyJhbGciOiJIUzI1NiJ9.eyJjdXN0b21lclN5c3RlbVNvdXJjZSI6MiwiY3VzdG9tZXJJZCI6NzI0MzksImV4cCI6MTY1NTE5MTE0NCwiY3VzdG9tZXJOYW1lIjoiIn0.oXikxrEqVxi3lfUs16j2pVqx9vM8_I8lQYpzivPF1VU'
  // const token = null
  // getWithdrawalMsg({ headers: { 'X-AuthToken': token, 'X-AuthShopId': 215 } }).then((res: any) => {
  //   if (res.code === '0') {
  //     data.availableAmount = res.data.availableAmount
  //     form.exchangeRate = res.data.exchangeRate
  //     form.feeRate = res.data.feeRate
  //   }
  // })
  axios({
    method: 'get',
    url: process.env.VUE_APP_URL + '/settlement/withdraw/manager/apply/info/get',
    headers: {
      'X-AuthToken': data.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    }
  }).then((res: any) => {
    const resData = res.data
    if (resData.code === '0') {
      data.availableAmount = resData.data.availableAmount
      form.exchangeRate = resData.data?.exchangeRate
      form.feeRate = resData.data.feeRate
    }
  })
}

// 提现金额失去焦点
const amountBlur = () => {
  getCalculateAmount()
}

// 计算费用
const [loading, getCalculateAmount] = useRequest(() => {
  console.log(form.withdrawAmountRmb)
  if (!form.withdrawAmountRmb || form.withdrawAmountRmb === '') {
    form.withdrawFee = 0
    form.withdrawAmountJp = 0
    return new Promise<void>((resolve) => {
      resolve()
    })
  }
  const formData = {
    withdrawAmountRmb: form.withdrawAmountRmb
  }
  return getCalculateAmountRes(formData).then((res: any) => {
    if (res.code === '0') {
      form.withdrawFee = res.data.withdrawFee
      form.withdrawAmountJp = res.data.withdrawAmountJp
    }
  })
})

// 确认提交
const submit = () => {
  const f = formRef.value
  f.validate((valid: boolean) => {
    if (valid) {
      data.upload = true
    }
  })
}

// 请求书上传成功回调
const uploadSuccess = (url: any) => {
  data.upload = false
  form.requestBookUrl = url
  const formData = toRaw(form)
  axios({
    method: 'post',
    url: process.env.VUE_APP_URL + '/settlement/withdraw/manager/apply',
    headers: {
      'X-AuthToken': data.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    },
    data: formData
  }).then((res: any) => {
    const resData = res.data
    if (resData.code === '0') {
      toBack()
      message.success({
        message: resData.msg || t('提交成功'),
        type: 'success',
        onClose: () => {}
      })
    } else
    if (resData.msg) {
      message.error(resData.msg)
    }
  })
}

// 返回
const toBack = () => {
  // router.replace(useRtfix('setupUser'))
  handleClose()
}

// dialog关闭
const handleClose = () => {
  emits('close')
}

// 获取token
const getToken = () => {
  console.log(store.getters.plat)
  console.log(props.platType)
  if (store.getters.plat === props.platType) {
    data.token = store.getters.token
    getMsg()
  } else {
    getTotherToken().then((res: any) => {
      data.token = res.data.token
      getMsg()
    })
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _unref(data).show,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(data).show) = $event)),
      width: 630,
      "before-close": handleClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(__props.platType.toUpperCase() + _unref(t)('提现')), 1),
          _createVNode(_component_el_form, {
            class: "Withdrawal-form",
            ref: (_value, _refs) => {
              _refs['formRef'] = _value
              formRef.value = _value
            },
            model: _unref(form),
            rules: _unref(rules),
            "label-width": "160px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('提现渠道'),
                prop: "withdrawChannelType"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "Withdrawal-form-select",
                    modelValue: _unref(form).withdrawChannelType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).withdrawChannelType) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(withdrawChannelTypeList, (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          value: item.value,
                          label: item.label
                        }, null, 8, ["value", "label"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('银行名称'),
                prop: "bankName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: _unref(form).bankName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).bankName) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: _unref(t)('请输入银行名称'),
                    maxlength: 10
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('支店名'),
                prop: "bankAddress"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: _unref(form).bankAddress,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).bankAddress) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: _unref(t)('请输入支店名')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('口座类别'),
                prop: "kzType"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "Withdrawal-form-select",
                    modelValue: _unref(form).kzType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).kzType) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(kzTypeList, (item) => {
                        return _createVNode(_component_el_option, {
                          key: item.value,
                          value: item.value,
                          label: item.label
                        }, null, 8, ["value", "label"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('银行账号'),
                prop: "bankNo"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: _unref(form).bankNo,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).bankNo) = $event)),
                    placeholder: _unref(t)('请输入银行账号'),
                    maxlength: 20
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('收款人名称'),
                prop: "beneficiaryName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: _unref(form).beneficiaryName,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).beneficiaryName) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: _unref(t)('请输入收款人名称'),
                    maxlength: 5
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                class: "Withdrawal-form-amount",
                label: _unref(t)('提现金额（RMB）'),
                prop: "withdrawAmountRmb"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    class: "Withdrawal-form-input",
                    modelValue: _unref(form).withdrawAmountRmb,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).withdrawAmountRmb) = $event)),
                    placeholder: _unref(t)('请输入提现金额'),
                    maxlength: 20,
                    controls: false,
                    min: 0,
                    precision: 2,
                    max: _unref(data).availableAmount,
                    onBlur: amountBlur
                  }, null, 8, ["modelValue", "placeholder", "max"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('可提现金额')) + ": " + _toDisplayString(_unref(data).availableAmount) + "元 ", 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('费率')) + ": " + _toDisplayString(_unref(form).feeRate) + "% ", 1)
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('提现手续费'),
                prop: "withdrawFee"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: _unref(form).withdrawFee,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).withdrawFee) = $event)),
                    modelModifiers: { trim: true },
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('汇率')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(form).exchangeRate), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('提现金额（JPY）')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: _unref(form).withdrawAmountJp,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).withdrawAmountJp) = $event)),
                    modelModifiers: { trim: true },
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('提现原因')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).withdrawReason,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).withdrawReason) = $event)),
                    rows: 4,
                    type: "textarea",
                    placeholder: _unref(t)('请输入提现原因'),
                    maxlength: 200,
                    "show-word-limit": true
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('电子邮件地址')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(userData).customerEmail), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_button, {
                        class: "btn",
                        type: "primary",
                        onClick: _unref(getCode),
                        disabled: _unref(count) > 0
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(count) > 0 ? _unref(tip) : _unref(t)('发送')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('邮箱验证码'),
                prop: "emailCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: _unref(form).emailCode,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).emailCode) = $event)),
                    modelModifiers: { trim: true },
                    placeholder: _unref(t)('请输入邮箱验证码')
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: submit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(data).upload)
      ? (_openBlock(), _createBlock(uploadApplication, {
          key: 0,
          form: _unref(form),
          onSuccess: uploadSuccess,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_unref(data).upload = false))
        }, null, 8, ["form"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})